/**
 * Removes item from array by given item index
 *
 * @example arrayRemoveAtIndex([1, 2, 3, 4, 5], 3) // [1, 2, 3, 5]
 */
export const arrayRemoveAtIndex = (array: any[], index: number): any[] => {
    return array.slice(0, index).concat(array.slice(index + 1))
}
